module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/fund-c810e06a942aeaa53c536c08b6de5389.svg";